import { useState } from "react";

import { ExternalLink, Icon, Span } from "@virtual-brain-lib/frontend-design-system/ui";
import type { MessageToolLink } from "@virtual-brain-lib/types";

export function LinkRow({ link }: { readonly link: MessageToolLink }) {
	const [faviconFailed, setFaviconFailed] = useState(false);
	const showFavicon = Boolean(link.favicon) && !faviconFailed;

	return (
		<div className="flex min-w-0">
			<ExternalLink
				className="group/link flex min-w-0 items-center gap-1.5 px-1 py-0.5"
				href={link.url}
			>
				{showFavicon ? (
					<img
						alt=""
						className="size-3.5 shrink-0 rounded-xs"
						src={link.favicon}
						onError={() => {
							setFaviconFailed(true);
						}}
					/>
				) : (
					<Icon color="defaultLight" name="globe" size="xs" />
				)}
				<Span
					className="truncate text-default transition-colors group-hover/link:text-default/70"
					variant="body-xs"
				>
					{link.url}
				</Span>
			</ExternalLink>
		</div>
	);
}
